import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [{
            path: '/',
            redirect: '/login'
        },

        {
            path: '/',
            component: () =>
                import ( /* webpackChunkName: "home" */ '@/pages/Home.vue'),
            meta: {

                title: '自述文件'
            },

            children: [{
                    //首页
                    path: 'Dashboard',
                    component: () =>
                        import ('@/pages/Dashboard.vue'),
                    meta: {
                        // 添加该字段，表示进入这个路由是需要登录的
                        requireAuth: true
                    }
                },
                { //数据中心-三方订单
                    path: '/thirdpartyOrderData',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/orderSummaryData/thirdpartyOrderData/index.vue'),
                    meta: {
                        title: '三方订单'
                    }
                },
                { //旅游中心-充值旅游活动
                    path: '/travelRechargeActivity',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/travel/travelRechargeActivity.vue'),
                    meta: {
                        title: '充值旅游活动'
                    }
                },
                { //旅游中心-旅游充值统计
                    path: '/travelRechargeRecord',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/travel/travelRechargeRecord.vue'),
                    meta: {
                        title: '旅游充值统计'
                    }
                },
                { //数据中心-订单
                    path: '/orderData',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/orderSummaryData/orderData.vue'),
                    meta: {
                        title: '订单'
                    }
                },
                { //数据中心-用户
                    path: '/userData',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/orderSummaryData/userData.vue'),
                    meta: {
                        title: '用户'
                    }
                },
                { //数据中心-司机
                    path: '/driverData',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/orderSummaryData/driverData.vue'),
                    meta: {
                        title: '司机'
                    }
                },
                { //数据中心-城市
                    path: '/cityData',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/orderSummaryData/city/cityData.vue'),
                    meta: {
                        title: '城市详情'
                    }
                },
                { //数据中心-车生活订单
                    path: '/autolifeOrderData',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/orderSummaryData/autolifeOrderData.vue'),
                    meta: {
                        title: '车生活订单'
                    }
                },
                {

                    //订单中心-订单管理
                    path: 'substituteDrivingOrder',
                    component: () =>
                        import ('../components/substituteDrivingOrder/substituteDrivingOrder.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //订单中心-服务中订单
                    path: 'ServiceOrder',
                    component: () =>
                        import ('../components/substituteDrivingOrder/ServiceOrder.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //订单中心-订单导出
                    path: 'orderExport',
                    component: () =>
                        import ('../components/substituteDrivingOrder/orderExport/orderExport.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //订单中心-历史订单导出
                    path: 'historyOrderExport',
                    component: () =>
                        import ('../components/substituteDrivingOrder/orderExport/historyOrderExport.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //订单中心-帮助中心
                    path: 'helpcenter',
                    component: () =>
                        import ('../components/helpCenter/HelpCenter.vue'),
                    meta: {

                        requireAuth: true
                    }
                },
                {
                    // 订单中心-项目跟踪
                    path: 'projectFollow',
                    component: () =>
                        import ('../components/projectFollow/ProjectFollow.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //订单中心-跨库查单
                    path: 'orderAll',
                    component: () =>
                        import ('../components/order/orderListsAll.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /* 订单中心 */
                    //  订单中心-历史订单
                    path: 'orderHistory',
                    component: () =>
                        import ('../components/substituteDrivingOrder/orderHistory.vue'),
                    meta: {
                        requireAuth: true
                    }
                },
                {
                    //订单中心-超速记录
                    path: '/overspeed',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/statistics/overspeed/overspeed.vue'),
                    meta: {
                        title: '超速记录'
                    }
                },
                { // 合伙人设置
                    path: 'distributionConfig',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/distributionConfig/distributionConfig.vue'),
                    meta: {
                        title: '合伙人设置'
                    }
                },
                { // 合伙人数据
                    path: 'distributionPromoterlists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/distributionConfig/heHuoRen/distributionPromoterlists.vue'),
                    meta: {
                        title: '合伙人数据'
                    }
                },
                { // 合伙人审核
                    path: 'distributionwithdrawLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/distributionConfig/shenHe/distributionwithdrawLists.vue'),
                    meta: {
                        title: '合伙人审核'
                    }
                },
                { // 提现审核
                    path: 'withdraw',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/distributionConfig/tiXianShenHe/withdraw.vue'),
                    meta: {
                        title: '提现审核'
                    }
                },

                { // 微信群设置 群列表
                    path: 'machineAccount',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/wxGroup/machineAccount.vue'),
                    meta: {
                        title: '客服微信'
                    }
                },

                { // 微信群设置 群列表
                    path: 'groupLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/wxGroup/groupLists.vue'),
                    meta: {
                        title: '群列表'
                    }
                },

                { // 线下推广 任务列表
                    path: '/offlinePromotionList',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/Offlinepromotion/offlinePromotionList.vue'),
                    meta: {
                        title: '任务列表'
                    }
                },
                { // 保险中心  案件列表
                    path: '/inseranceLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/getInsurance/inseranceLists.vue'),
                    meta: {
                        title: '案件列表'
                    }
                },
                {
                    path: '/adminBusiness',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/business/adminBusiness.vue'),
                    meta: {
                        title: '商家合作'
                    }
                },
                {
                    path: '/adminUnionPayConsumerStatistics',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/group/adminUnionPayConsumerStatistics.vue'),
                    meta: {
                        title: '集团管理'
                    }
                },
                {
                    path: '/adminFuliguan',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/fuliguan/adminFuliguan.vue'),
                    meta: {
                        title: '福利官'
                    }
                },
                {
                    path: '/customerRechargeManage',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/customerRechargeManage/customerRechargeManage.vue'),
                    meta: {
                        title: '客户充值管理'
                    }
                },
                {
                    path: '/customerRechargeStat',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/customerRechargeManage/customerRechargeStat.vue'),
                    meta: {
                        title: '客户充值统计'
                    }
                },
                { // 运营中心-营销管理-司机加速包
                    path: '/adminDelayReduction',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/delayReduction/adminDelayReduction.vue'),
                    meta: {
                        title: '司机加速包'
                    }
                },
                {
                    path: '/adminOrderConnectLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/orderConnect/adminOrderConnectLists.vue'),
                    meta: {
                        title: '连单活动列表'
                    }
                },

                {
                    path: '/adminLabelLists',
                    component: () =>
                        import ( /* webpackChunkName: "donate" */ '@/components/operate/operationsCenterAdmin/label/adminLabelLists.vue'),
                    meta: {
                        title: '标签管理'
                    }

                },
                // {
                //     path: '/otherAdvertConf',
                //     component: () =>
                //         import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/advert/advertInformation/advertInformation.vue'),
                //     meta: {
                //         title: '广告配置'
                //     }
                // },
                { // 广告配置 下
                    path: '/otherAdvertLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/advert/advertInformation/otherAdvertLists.vue'),
                    meta: {
                        title: '广告库'
                    }
                },
                { // 广告配置 下
                    path: '/otherAdvertAppointLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/advert/advertAppoint/otherAdvertAppointLists.vue'),
                    meta: {
                        title: '广告位'
                    }
                },
                // { // 优惠券模块
                //     path: '/otherCoupon',
                //     component: () =>
                //         import ( /* webpackChunkName: "donate" */ '@/components/operate/operationsCenterAdmin/coupon/couponType/couponClassLists.vue'),
                //     meta: {
                //         title: '优惠券'
                //     }
                // },
                { // 优惠券模块下
                    path: '/otherCouponType',
                    component: () =>
                        import ( /* webpackChunkName: "donate" */ '@/components/operate/operationsCenterAdmin/coupon/couponType/otherCouponType.vue'),
                    meta: {
                        title: '优惠券类型'
                    }
                },
                { // 优惠券模块下
                    path: '/otherCouponLists',
                    component: () =>
                        import ( /* webpackChunkName: "donate" */ '@/components/operate/operationsCenterAdmin/coupon/couponLists/otherCouponLists.vue'),
                    meta: {
                        title: '优惠券列表'
                    }
                },
                {
                    path: '/otherChannelPackage',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/couponPackage/otherChannelPackage.vue'),
                    meta: {
                        title: '渠道优惠券礼包'
                    }
                },
                // {
                //     path: '/couponPackageReceiveLists',
                //     component: () =>
                //         import ( /* webpackChunkName: "dashboard" */ '@/components/operate/operationsCenterAdmin/couponPackage/couponPackageReceiveLists.vue'),
                //     meta: {
                //         title: '领取记录'
                //     }
                // },
                {
                    path: '/otherChannelPriority',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/operationsCenterAdmin/priority/otherChannelPriority.vue'),
                    meta: {
                        title: '优享券'
                    }
                },
                { // 活动模块下
                    path: '/teamActivityLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/groupactivity/teamActivityLists.vue'),
                    meta: {
                        title: '活动列表'
                    }
                },
                { //组队活动模块下 不显示这个菜单，因为是四级  四级菜单写好的时候用这个
                    path: '/teamGroupLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/groupactivity/teamGroupLists.vue'),
                    meta: {
                        title: '组队列表'
                    }
                },

                {
                    //在乘客端模块下
                    path: '/dynamicMarkup',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/dynamicmarkup/dynamicMarkup.vue'),
                    meta: {
                        title: '动态加价'
                    }
                },
                {
                    //在乘客端模块下
                    path: '/consumerWaitLess',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/consumer/consumerWaitLess.vue'),
                    meta: {
                        title: '等待减免'
                    }
                },

                {
                    //在活动模块下
                    path: '/offineCard',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/offlinediscountcard/offineCard.vue'),
                    meta: {
                        title: '线下优惠卡'
                    }
                },
                {
                    //在活动模块下
                    path: '/offineCardLog',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/offlinediscountcard/offineCardLog.vue'),
                    meta: {
                        title: '优惠卡日志'
                    }
                },
                {
                    //在乘客端模块下 原推广码模块更改为 投放管理 投放类目列表
                    path: '/promotionCategory',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/statisticPromotion/promotionCategoryLists.vue'),
                    meta: {
                        title: '投放类目'
                    }
                },

                {
                    //在乘客端模块下 推广码模块下 二维码统计 现已变更为投放统计
                    path: '/statisticPromotion',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/statisticPromotion/statisticPromotion.vue'),
                    meta: {
                        title: '投放统计'
                    }
                },
                {
                    //在乘客端模块下 推广码模块下 二维码列表
                    path: '/promotionQRLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/statisticPromotion/promotionQRLists.vue'),
                    meta: {
                        title: '投放管理'
                    }
                },

                {
                    //在乘客端模块下 推广码模块下
                    path: '/promotionLabelLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/statisticPromotion/promotionLabelLists.vue'),
                    meta: {
                        title: '标签列表'
                    }
                },

                { // 抽奖活动模块下抽奖 四级菜单写好的时候用这个
                    path: '/lotteryPrizeLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/prize/lotteryPrizeLists.vue'),
                    meta: {
                        title: '奖品列表'
                    }
                },

                {
                    path: '/lotteryPrizeRecordLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/prize/lotteryPrizeRecordLists.vue'),
                    meta: {
                        title: '中奖记录'
                    }
                },

                {
                    path: '/consumerReward',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/consumerReward/consumerReward.vue'),
                    meta: {
                        title: '乘客分享'
                    }
                },
                { // 运营中心-乘客端-畅行卡
                    path: '/consumerCard',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/card/consumerCard.vue'),
                    meta: {
                        title: '畅行卡  '
                    }
                },

                { // 运营中心-乘客端-畅行卡
                    path: '/consumerPurchaseHistory',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/card/purchaseHistory/consumerPurchaseHistory.vue'),
                    meta: {
                        title: '购买记录'
                    }
                },
                { // 运营中心-乘客端-畅行卡
                    path: '/consumerUsagRecord',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/passenger/card/usagRecord/consumerUsagRecord.vue'),
                    meta: {
                        title: '使用记录'
                    }
                },

                {
                    path: '/workPlateList',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/driver/workPlate/workPlateList.vue'),
                    meta: {
                        title: '司机推广码（工牌）'
                    }
                },
                {
                    path: '/inviteCode',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/driver/inviteCode/inviteCode.vue'),
                    meta: {
                        title: '司机邀请拉新'
                    }
                },
                {
                    path: '/inviteDriverCode',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/driver/inviteDriverCode/inviteDriverCode.vue'),
                    meta: {
                        title: '扫司机工牌码拉新'
                    }
                },

                {
                    path: '/returnfee',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/driver/returnfee/returnfee.vue'),
                    meta: {
                        title: '返程费'
                    }
                },
                { // 原司机任务
                    path: '/taskLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/driver/task/taskLists.vue'),
                    meta: {
                        title: '司机任务'
                    }
                },
                { // 2024年11月19日上线，此模块因为后台接口没开发完，没上线
                    path: '/taskLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/operate/driver/taskNew/taskNewLists.vue'),
                    meta: {
                        title: '司机任务新'
                    }
                },

                {

                    //bug管理
                    path: 'bugManagement',
                    component: () =>
                        import ('../components/bugManagement/bugManagement.vue'),
                    meta: {

                        requireAuth: true

                    }
                },

                // {
                //     //乘客等待减免  已转移到运营中心
                //     path: '/waitLess',
                //     component: () =>
                //         import ( /* webpackChunkName: "city" */ '@/components/consumer/setConsumerWaitDiscountFee.vue'),
                //     meta: {
                //         title: '乘客等待减免'
                //     }
                // },
                {
                    //人寿保险订单
                    path: '/insuranceCity',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/insurance/insuranceCity.vue'),
                    meta: {
                        title: '保险城市'
                    }
                },
                {
                    //保险订单-订单列表
                    path: '/insuranceOrder',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/insurance/insuranceOrder.vue'),
                    meta: {
                        title: '订单列表'
                    }
                },



                {
                    // 分润列表
                    path: 'percentage',
                    component: () =>
                        import ('../components/percentage/percentage.vue'),
                    meta: {

                        requireAuth: true

                    }
                },


                {
                    //轮播活动
                    path: 'activeCircleList',
                    component: () =>
                        import ('../components/active/activeCircleList.vue'),
                    meta: {

                        requireAuth: true
                    }
                },
                {
                    path: '/serviceFee',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/serviceFee/serviceFee.vue'),
                    meta: {
                        title: '服务费管理'
                    }
                },
                {
                    //收费规则配置
                    path: '/insuranceFeeRule',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/insurance/insuranceFeeRule.vue'),
                    meta: {
                        title: '收费规则配置'
                    }
                },
                {
                    //保险金明细
                    path: '/insuranceFeeDetail',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/insurance/insuranceFeeDetail.vue'),
                    meta: {
                        title: '保险金明细'
                    }
                },
                {
                    path: '/serviceFeeMsgActive',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/serviceFeeMsgActive/serviceFeeMsgActive.vue'),
                    meta: {
                        title: '服务费短信活动'
                    }
                },
                {
                    path: '/partnerList',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/Partner/partnerList.vue'),
                    meta: {
                        title: '第三方配置'
                    }
                },
                {
                    path: '/contractList',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/driver/contract/contractList.vue'),
                    meta: {
                        title: '电子合同'
                    }
                },
                {
                    path: '/serviceDriverFeeExcel',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/company/getCityplatformFee/serviceDriverFeeExcel.vue'),
                    meta: {
                        title: '订单抽成统计'
                    }
                },
                { //看云接口叫“各城市服务费列表” 模块 ： 数据统计-服务费预存款统计-城市司机抽成总计
                    path: '/driverServiceFeeCityLists',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/statistics/driverServiceFeeCityLists.vue'),
                    meta: {
                        title: '城市司机抽成总计'
                    }
                },

                { // 支付宝优惠券-优惠券管理
                    path: '/alipayCoupon',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/alipayCoupon/alipayCouponList.vue'),
                    meta: {
                        title: '优惠券管理'
                    }
                },
                { // 支付宝优惠券-推广计划管理
                    path: '/aliDevlivery',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/aliDevlivery/aliDevliveryList.vue'),
                    meta: {
                        title: '推广计划管理'
                    }
                },
                { // 支付宝优惠券-优惠券码管理
                    path: '/alipayCouponCode',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/alipayCoupon/alipayCouponCode/alipayCouponCodeList.vue'),
                    meta: {
                        title: '优惠券码管理'
                    }
                },
                {
                    path: '/businessWalletCash',
                    component: () =>
                        import ( /* webpackChunkName: "city" */ '@/components/business/businessCashLists/businessWalletCash.vue'),
                    meta: {
                        title: '商家提现'
                    }
                },



                {
                    //保险审核
                    path: 'inserance',
                    component: () =>
                        import ('../components/driver/inserance/inserance.vue'),
                    meta: {

                        requireAuth: true
                    }
                },
                {
                    //司机基础配置
                    path: 'driverProtect',
                    component: () =>
                        import ('../components/driver/driverProtect/driverProtect.vue'),
                    meta: {

                        requireAuth: true
                    }
                },
                {
                    // 超级管理员
                    path: 'administrator',
                    component: () =>
                        import ('../components/administrator/AdminIstrator.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    // 超管角色
                    path: 'administratorRole',
                    component: () =>
                        import ('../components/administratorRole/administratorRole.vue'),
                    meta: {

                        requireAuth: true

                    }
                },

                {
                    // 城市管理
                    path: 'city',
                    component: () =>
                        import ('../components/city/city.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    // 城市状态
                    path: 'cityStatus',
                    component: () =>
                        import ('../components/city/cityStatus.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    // 开城信息列表
                    path: 'auditCity',
                    component: () =>
                        import ('../components/city/auditCity.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /** 系统管理 */
                    //    app更新管理
                    path: 'appToUpdate',
                    component: () =>
                        import ('../components/appToUpdate/appToUpdate.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //原bug管理，改成意见建议
                    path: 'bugManagement',
                    component: () =>
                        import ('../components/bugManagement/bugManagement.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //bug管理
                    path: 'bugList',
                    component: () =>
                        import ('../components/bugList/bugList.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /**市场管理**/
                    //公司管理
                    path: 'company',
                    component: () =>
                        import ('../components/company/company.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /**日志管理 */
                    //   超管员日志
                    path: 'superAdminLog',
                    component: () =>
                        import ('../components/logList/superAdminLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //推送日志
                    path: 'pushLog',
                    component: () =>
                        import ('../components/logList/pushLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //用户日志
                    path: 'userLog',
                    component: () =>
                        import ('../components/logList/userLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //短信日志
                    path: 'messageLog',
                    component: () =>
                        import ('../components/logList/messageLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //验证码日志
                    path: 'codeLog',
                    component: () =>
                        import ('../components/logList/codeLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },





                {
                    /* 乘客管理 */
                    //乘客信息
                    path: 'user',
                    component: () =>
                        import ('../components/user/user.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //乘客账单
                    path: 'userBill',
                    component: () =>
                        import ('../components/user/userBill.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //乘客绑卡
                    path: 'userBankCard',
                    component: () =>
                        import ('../components/user/userBankCard/userBankCard.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //用户订单需求
                    path: 'demandLists',
                    component: () =>
                        import ('../components/demandLists/demandLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //乘客信息导出
                    path: 'userExport',
                    component: () =>
                        import ('../components/user/userExport.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //乘客在线支付
                    path: 'consumerRecharge',
                    component: () =>
                        import ('../components/user/consumerRecharge.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //优惠券列表
                    path: 'couponLists',
                    component: () =>
                        import ('../components/coupon/couponLists/couponLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //优惠券类型
                    path: 'couponType',
                    component: () =>
                        import ('../components/coupon/couponType/couponClassLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //优惠券日志
                    path: 'couponRecordLists',
                    component: () =>
                        import ('../components/coupon/couponRecordLists/couponRecordLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //订单模式
                    path: 'orderModel',
                    component: () =>
                        import ('../components/orderModel/orderModel.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //通知,原 公告
                    path: 'article',
                    component: () =>
                        import ('../components/article/article.vue'),
                    meta: {

                        requireAuth: true
                    }
                },
                {

                    //公告通知 公告
                    path: 'adminnoticelist',
                    component: () =>
                        import ('../components/article/notice/adminNoticeLists.vue'),
                    meta: {

                        requireAuth: true
                    }
                },
                {

                    //更新缓存
                    path: 'synchronization',
                    component: () =>
                        import ('../components/upTableSubmit/synchronization.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //异业联盟
                    path: 'ipcShopping',
                    component: () =>
                        import ('../components/ipcShopping/ipcShopping.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //签约优惠
                    path: 'signingPreferential',
                    component: () =>
                        import ('../components/driver/signingPreferential/signingPreferential.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机段位
                    path: 'driverDan',
                    component: () =>
                        import ('../components/driver/driverDan/driverDan.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //招募司机
                    path: '/driverRecruit',
                    component: () =>
                        import ('../components/driver/driverRecruit/driverRecruit.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //上传文件加分加券（批量操作）
                    path: '/batch',
                    component: () =>
                        import ('../components/driver/batch/batch.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机提现
                    path: '/driverWalletCash',
                    component: () =>
                        import ('../components/driver/driverWalletCash/driverWalletCash.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /* 司机 */
                    //司机信息
                    path: 'driver',
                    component: () =>
                        import ('../components/driver/driver.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //司机分数
                    path: 'driverPoints',
                    component: () =>
                        import ('../components/driver/driverPoints.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //司机充值记录
                    path: 'driverRecharge',
                    component: () =>
                        import ('../components/driver/driverRecharge.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /* 司机 */
                    //虚拟司机
                    path: 'driverVirtual',
                    component: () =>
                        import ('../components/driver/driverVirtual.vue'),
                    meta: {

                        requireAuth: true

                    }
                },

                {

                    //签约审核
                    path: 'determine',
                    component: () =>
                        import ('../components/determine/determine.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //绑卡信息
                    path: 'driverBankCard',
                    component: () =>
                        import ('../components/driver/driverBankCard/driverBankCard.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机业绩导出订单信息
                    path: 'getPerformanceCSV',
                    component: () =>
                        import ('../components/driver/getPerformanceCSV.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                // {
                //     /** 广告管理 */  转移到运营中心
                //     //  广告位
                //     path: 'advertAppoint',
                //     component: () =>
                //         import ('../components/advert/advertAppoint/advertAppoint.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                // {

                //     //广告库
                //     path: 'advertInformation',
                //     component: () =>
                //         import ('../components/advert/advertInformation/advertInformation.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                {

                    //司机推广
                    path: 'driverPromote',
                    component: () =>
                        import ('../components/driver/driverPromote/driverPromote.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //推广审核
                    path: 'examineDriverPromote',
                    component: () =>
                        import ('../components/driver/examineDriverPromote/examineDriverPromote.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //推荐地址
                    path: 'recommendAddress',
                    component: () =>
                        import ('../components/recommendAddress/recommendAddress.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //集团管理
                    path: 'group',
                    component: () =>
                        import ('../components/group/group.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //城市小组
                    path: 'cityTeam',
                    component: () =>
                        import ('../components/city/cityTeam.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                //  通讯服务-短信详情
                {
                    path: '/msgCountDetails',
                    component: () =>
                        import ('../components/city/msgCountDetails.vue'),
                    meta: {
                        requireAuth: true
                    },
                },
                // 通讯服务-短信收费配置
                {
                    path: '/msgGroupList',
                    component: () =>
                        import ('../components/city/msgGroup/msgGroupList.vue'),
                    meta: {
                        requireAuth: true
                    },
                },
                // 系统管理-支付宝配置
                {
                    path: '/alipay',
                    component: () =>
                        import ('../components/payConfig/alipay/alipay.vue'),
                    meta: {
                        requireAuth: true
                    },
                },
                // 系统管理-微信商户号
                {
                    path: '/wechatPay',
                    component: () =>
                        import ('../components/payConfig/wechat/wechat.vue'),
                    meta: {
                        requireAuth: true
                    },
                },
                //  通讯服务-隐私通话
                // {
                //     path: '/privateNumber',
                //     component: () =>
                //         import ('../components/city/private/privateNumber.vue'),
                //     meta: {
                //         requireAuth: true
                //     },
                // },
                //  通讯服务-号码管理
                {
                    path: '/virtualNumber',
                    component: () =>
                        import ('../components/city/private/virtualNumber.vue'),
                    meta: {
                        requireAuth: true
                    },
                },
                //  通讯服务-城市配置
                {
                    path: '/virtualNumberCity',
                    component: () =>
                        import ('../components/city/private/virtualNumberCity.vue'),
                    meta: {
                        requireAuth: true
                    },
                },
                {

                    //管理员日志
                    path: 'adminLog',
                    component: () =>
                        import ('../components/logList/adminLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机活动积分日志
                    path: 'driverRecordActivityPointLists',
                    component: () =>
                        import ('../components/logList/driverRecordActivityPointLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机日志
                    path: 'driverLog',
                    component: () =>
                        import ('../components/logList/driverLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //配置管理
                    path: 'confLists',
                    component: () =>
                        import ('../components/conf/confLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //标签管理
                    path: 'labelLists',
                    component: () =>
                        import ('../components/label/labelLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //客服管理
                    path: 'adminList',
                    component: () =>
                        import ('../components/admin/adminList.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //角色管理
                    path: 'adminRoleLists',
                    component: () =>
                        import ('../components/system/adminRoleLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //清除无用图片
                    path: 'clearImgSubmit',
                    component: () =>
                        import ('../components/upTableSubmit/clearImgSubmit.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /**数据统计 */
                    //   乘客统计
                    path: 'consumerStatistics',
                    component: () =>
                        import ('../components/statistics/consumerStatistics.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //   订单核算
                    path: 'orderCheck',
                    component: () =>
                        import ('../components/statistics/orderCheck.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //数据统计-乘客下单统计
                    path: 'consumerOrderNumLists',
                    component: () =>
                        import ('../components/statistics/consumerOrderNumLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //数据统计-跑腿订单量统计
                    path: 'getLegWorkOrderCount',
                    component: () =>
                        import ('../components/statistics/getLegWorkOrderCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //检车卡列表
                    path: 'InspectionCard',
                    component: () =>
                        import ('../components/statistics/InspectionCard.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //清分列表
                    path: 'payLists',
                    component: () =>
                        import ('../components/payLists/payLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机今日排行
                    path: 'driverCount',
                    component: () =>
                        import ('../components/statistics/driverCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //三倍充值
                    path: 'consumerTripleRecordLists',
                    component: () =>
                        import ('../components/statistics/consumerTripleRecordLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //平安发卡
                    path: 'pingan',
                    component: () =>
                        import ('../components/pingan/pingan.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机统计数据
                    path: 'driverStatistics',
                    component: () =>
                        import ('../components/statistics/driverStatistics.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //司机在线时长
                    path: 'driverDriverStatusLists',
                    component: () =>
                        import ('../components/statistics/driverDriverStatusLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //订单统计
                    path: 'orderStatistics',
                    component: () =>
                        import ('../components/statistics/orderStatistics.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //微信支付
                    path: 'wechat',
                    component: () =>
                        import ('../components/wechat/wechat.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //支付宝支付
                    path: 'alipay',
                    component: () =>
                        import ('../components/alipay/alipay.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /** 现金券 */
                    // 现金券列表
                    path: 'walletkey',
                    component: () =>
                        import ('../components/walletkey/walletkey.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //现金券日志
                    path: 'walletkeylog',
                    component: () =>
                        import ('../components/walletkey/walletkeylog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /** 九州优惠卡 */
                    // 现金券列表
                    path: 'discountCard',
                    component: () =>
                        import ('../components/discountCard/discountCard.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //现金券日志
                    path: 'discountCardLog',
                    component: () =>
                        import ('../components/discountCard/discountCardLog.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //现金券日志分类
                    path: 'discountCardType',
                    component: () =>
                        import ('../components/discountCard/discountCardType/discountCardType.vue'),
                    meta: {

                        requireAuth: true

                    }
                },

                {
                    /** 招商加盟 */
                    // 招商加盟
                    path: 'merChants',
                    component: () =>
                        import ('../components/merchants/merChants.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    /** 挪车码管理 */
                    // 挪车码
                    path: 'movecar',
                    component: () =>
                        import ('../components/movecar/movecar.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {

                    //活跃度乘客统计
                    path: 'activeConsumerCount',
                    component: () =>
                        import ('../components/statistics/activeConsumerCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //活跃度司机统计
                    path: 'activeDriverCount',
                    component: () =>
                        import ('../components/statistics/activeDriverCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //全部城市订单
                    path: 'getAllCityOrderCount',
                    component: () =>
                        import ('../components/statistics/getAllCityOrderCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //乘客加价统计
                    path: 'dynamic',
                    component: () =>
                        import ('../components/statistics/dynamic.vue'),
                    meta: {

                        requireAuth: true

                    }
                },

                {
                    // 数据统计模块下短信统计
                    path: 'msgNum',
                    component: () =>
                        import ('../components/statistics/msgNum.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //全部城市司机
                    path: 'getAllCityDriverCount',
                    component: () =>
                        import ('../components/statistics/getAllCityDriverCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //全部城市乘客
                    path: 'getAllCityConsumerCount',
                    component: () =>
                        import ('../components/statistics/getAllCityConsumerCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //数据统计-全国订单金额
                    path: 'getAllCityAmountCount',
                    component: () =>
                        import ('../components/statistics/getAllCityAmountCount/getAllCityAmountCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    // 数据统计-第三方订单
                    path: 'thirdCityOrderCount',
                    component: () =>
                        import ('../components/statistics/thirdCityOrderCount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //第三方合作数据
                    path: 'thirdJump',
                    component: () =>
                        import ('../components/statistics/thirdJump.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //服务费管理导出
                    path: 'serviceFeeExcel',
                    component: () =>
                        import ('../components/serviceFee/serviceFeeExcel.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //司机数量比对
                    path: 'driverCountInfo',
                    component: () =>
                        import ('../components/statistics/driverCountInfo/driverCountInfo.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //司机预存款统计
                    path: 'driverServiceFee',
                    component: () =>
                        import ('../components/statistics/driverServiceFee.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //城市预存款统计
                    path: 'cityServiceFee',
                    component: () =>
                        import ('../components/statistics/cityServiceFee.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //隐私通话费用统计
                    path: 'privatenoServiceFee',
                    component: () =>
                        import ('../components/statistics/privatenoServiceFee.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //会员管理-会员等级
                    path: 'memberLists',
                    component: () =>
                        import ('../components/member/memberLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //会员管理-会员设置
                    path: 'getMemberConfigDetail',
                    component: () =>
                        import ('../components/member/getMemberConfigDetail.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //会员管理-会员日
                    path: 'MemberDay',
                    component: () =>
                        import ('../components/member/MemberDay.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //会员管理-会员日订单
                    path: 'MemberDayOrder',
                    component: () =>
                        import ('../components/member/MemberDayOrder.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //数据统计-山东银联-财务打款对账
                    path: 'getFinancialAmount',
                    component: () =>
                        import ('../components/statistics/shanDongUnionPay/getFinancialAmount.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //集团账单
                    path: 'unionPayGroupStatistics',
                    component: () =>
                        import ('../components/statistics/shanDongUnionPay/unionPayGroupStatistics.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //乘客
                    path: 'unionPayConsumerStatistics',
                    component: () =>
                        import ('../components/statistics/shanDongUnionPay/unionPayConsumerStatistics.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //司机
                    path: 'unionPayDriverStatistics',
                    component: () =>
                        import ('../components/statistics/shanDongUnionPay/unionPayDriverStatistics.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //腾讯出行发票
                    path: 'invoice',
                    component: () =>
                        import ('../components/invoice/invoiceLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //积分商城-司机积分-任务大厅（积分设置）
                    path: 'integralconfig',
                    component: () =>
                        import ('../components/integralconfig/driver/integralconfig.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //积分商城-司机积分-司机积分列表
                    path: 'driverIntergralList',
                    component: () =>
                        import ('../components/integralconfig/driver/driverIntergralList.vue'),
                    meta: {

                        requireAuth: true

                    }
                },

                {
                    //积分商城-积分商品
                    path: 'IntergralGoods',
                    component: () =>
                        import ('../components/integralconfig/IntergralGoods/IntergralGoods.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    // 积分商城-乘客积分-乘客订单
                    path: 'consumerOrder',
                    component: () =>
                        import ('../components/integralconfig/consumer/consumerOrder.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    // 积分商城-乘客积分-乘客积分列表
                    path: 'consumerIntergralList',
                    component: () =>
                        import ('../components/integralconfig/consumer/consumerIntergralList.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //九州合作服务商-九州合作服务商列表
                    path: 'serviceLists',
                    component: () =>
                        import ('../components/service/serviceLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                // {
                //     //九州合作服务商-服务商城市关联列表
                //     path: 'bindCityServiceLists',
                //     component: () =>
                //         import ('../components/service/bindCityServiceLists.vue'),
                //     meta: {

                //         requireAuth: true

                //     }
                // },
                {
                    //九州合作服务商-转派订单列表
                    path: 'serviceOrderLists',
                    component: () =>
                        import ('../components/service/serviceOrderLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //金牌司机
                    path: 'serviceOrderLists',
                    component: () =>
                        import ('../components/service/serviceOrderLists.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //商品草稿列表
                    path: 'productDraftQuery',
                    component: () =>
                        import ('../components/product/productDraftQuery.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //商品上架列表
                    path: 'productonlineQuery',
                    component: () =>
                        import ('../components/product/productonlineQuery.vue'),
                    meta: {

                        requireAuth: true

                    }
                },
                {
                    //抖音订单列表
                    path: 'orderListQuery',
                    component: () =>
                        import ('../components/product/orderListQuery.vue'),
                    meta: {

                        requireAuth: true

                    }
                }
            ]
        },
        {
            path: '/Login',
            component: () =>
                import ('../pages/Login.vue'),
            name: 'login'
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js